import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    unitsLoading: false,
    units: null,
    invalidate: false,
  },
  actions,
  mutations,
  getters,
};
